import "flatpickr/dist/flatpickr.min.css";
import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

function DatePicker() {
  flatpickr(".js-date-picker", {
    locale: Japanese,
    dateFormat: "Y/m/d",
  });
}

export { DatePicker };
